import { useEffect } from "react";

import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";

import useMainNavigationStore from "../../stores/useMainNavigationStore";
import { NOTIFICATIONS_COUNT } from "./gql";

const NOTIFICATIONS_ITEM_ID = "notifications";

const useMainNavigationNotificationsCounter = () => {
  const setItemCount = useMainNavigationStore((state) => state.setItemCount);

  const { data } = usePolledQuery<{ notificationCount: number }>(NOTIFICATIONS_COUNT, {
    pollingGroup: PollingIntervalGroups.Long,
  });

  useEffect(() => {
    const count = data?.notificationCount ?? 0;
    setItemCount(NOTIFICATIONS_ITEM_ID, count);
  }, [data, setItemCount]);

  return data?.notificationCount ?? 0;
};

export default useMainNavigationNotificationsCounter;
